/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Support_FailedInputs */

const th_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตรวจสอบการรองรับวิดีโอของเบราว์เซอร์ไม่ได้ ลองอีกครั้ง`)
};

const en_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not check this browser’s video support. Try again.`)
};

const ja_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザーの映像対応を確認できませんでした。もう一度お試しください。`)
};

const zh_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法检查此浏览器的视频支持情况。请重试。`)
};

const es_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido comprobar la compatibilidad de vídeo de este navegador. Inténtalo de nuevo.`)
};

const pt_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível verificar o suporte de vídeo deste navegador. Tente de novo.`)
};

const id_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan video peramban ini tidak bisa diperiksa. Coba lagi.`)
};

const fr_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de vérifier la prise en charge vidéo de ce navigateur. Réessayez.`)
};

const tl_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi masuri ang suporta ng browser na ito sa video. Subukang muli.`)
};

const vi_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kiểm tra được hỗ trợ video của trình duyệt này. Thử lại.`)
};

const ko_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 브라우저의 영상 지원을 확인하지 못했습니다. 다시 시도하세요.`)
};

const de_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Video-Unterstützung dieses Browsers ließ sich nicht prüfen. Versuche es erneut.`)
};

const ru_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось проверить поддержку видео в этом браузере. Попробуйте снова.`)
};

const tr_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu tarayıcının görüntü desteği denetlenemedi. Yeniden deneyin.`)
};

const it_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile verificare il supporto video di questo browser. Riprova.`)
};

const pl_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się sprawdzić obsługi obrazu w tej przeglądarce. Spróbuj ponownie.`)
};

const uk_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося перевірити підтримку відео в цьому браузері. Спробуйте ще раз.`)
};

const hi_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ब्राउज़र का वीडियो समर्थन जाँचा नहीं जा सका। फिर कोशिश करें।`)
};

const ar_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر التحقق من دعم الفيديو في هذا المتصفح. أعد المحاولة.`)
};

const ms_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokongan video pelayar ini tidak dapat disemak. Cuba lagi.`)
};

const bn_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ব্রাউজারের ভিডিও সমর্থন যাচাই করা যায়নি। আবার চেষ্টা করুন।`)
};

const zh_tw2_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法檢查這個瀏覽器的影片支援。請再試一次。`)
};

const zh_hk2_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法檢查這個瀏覽器的短片支援。請再試一次。`)
};

const ur_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس براؤزر کی ویڈیو سہولت جانچی نہ جا سکی۔ دوبارہ کوشش کریں۔`)
};

const fa_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پشتیبانی تصویری این مرورگر بررسی نشد. دوباره تلاش کنید.`)
};

const sw_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwezo wa video wa kivinjari hiki haukuweza kukaguliwa. Jaribu tena.`)
};

const nl_video_support_failed = /** @type {(inputs: Video_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De videoondersteuning van deze browser kon niet worden gecontroleerd. Probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "Could not check this browser’s video support. Try again." |
*
* @param {Video_Support_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_support_failed = /** @type {((inputs?: Video_Support_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Support_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_support_failed(inputs)
	if (locale === "ja") return ja_video_support_failed(inputs)
	if (locale === "zh") return zh_video_support_failed(inputs)
	if (locale === "es") return es_video_support_failed(inputs)
	if (locale === "pt") return pt_video_support_failed(inputs)
	if (locale === "id") return id_video_support_failed(inputs)
	if (locale === "fr") return fr_video_support_failed(inputs)
	if (locale === "tl") return tl_video_support_failed(inputs)
	if (locale === "vi") return vi_video_support_failed(inputs)
	if (locale === "ko") return ko_video_support_failed(inputs)
	if (locale === "de") return de_video_support_failed(inputs)
	if (locale === "ru") return ru_video_support_failed(inputs)
	if (locale === "tr") return tr_video_support_failed(inputs)
	if (locale === "it") return it_video_support_failed(inputs)
	if (locale === "pl") return pl_video_support_failed(inputs)
	if (locale === "uk") return uk_video_support_failed(inputs)
	if (locale === "hi") return hi_video_support_failed(inputs)
	if (locale === "ar") return ar_video_support_failed(inputs)
	if (locale === "ms") return ms_video_support_failed(inputs)
	if (locale === "bn") return bn_video_support_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_video_support_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_video_support_failed(inputs)
	if (locale === "ur") return ur_video_support_failed(inputs)
	if (locale === "fa") return fa_video_support_failed(inputs)
	if (locale === "sw") return sw_video_support_failed(inputs)
	if (locale === "nl") return nl_video_support_failed(inputs)
	return en_video_support_failed(inputs)
});